import { ReactNode } from "react";
import { Card } from "react-bootstrap";

export function CardHeader( { children }: { children: ReactNode } ) {
    return <Card.Header className="d-flex flex-row align-items-center gap-2">
        {children}
    </Card.Header>;
}
